module.exports = __webpack_public_path__ + "images/home/index/mobile/values-timeline-screenshot-5ceaaffdae79a132cd928f57350e2c83.png";